import React from 'react';

const CheckmarkIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="7.25" stroke="black" strokeWidth="1.5" />
      <path
        d="M5.2 9.2L6.49319 10.4415C6.88586 10.8184 7.50792 10.8121 7.89282 10.4272L11.6 6.72001"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CheckmarkIcon;
